<template>
  <div>
    <div class="vx-row mb-10">
      <div class="vx-col w-full">
        <h4>
          <span class="inline-block align-middle">
            {{ $t('Internet Service Providers') }}
          </span>
        </h4>
        <p class="mt-3 text-gray-500 text-md">
          {{ $t("Reach audience across all internet service providers and mobile carriers.") }}
        </p>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <div class="autocomplete">
          <input id="create-campaign-s3-isp-search-input" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" v-model="filterText" :placeholder="$t('Search for provider.')" class="autocomplete-input">
        </div>
      </div>
    </div>

    <div class="vx-row mt-6 mb-5">
      <div class="vx-col w-full">
        <vs-checkbox id="create-campaign-s3-isp-select-all-button" class="ml-0" color="#6DC5D0" v-model="select_all" @change="selectAll()">{{ $t('Select All') }}</vs-checkbox>
      </div>
    </div>

    <div class="vx-row pt-3 h-64 overflow-y-scroll treeContainer mx-0">
      <div class="vx-col w-full">
        <tree v-show="isps_db.length" :data="tree" :filter="filterText" :options="treeOptions" ref="tree" @node:unchecked="removeIspFromTree" @node:checked="addIspFromTree">
          <span class="tree-text" slot-scope="{ node }">
            <template>
              <span v-if="node.data.hasOwnProperty('isps_count')" class="inline-block align-middle mr-3">
                {{ node.text }} ({{ selectIspsCountPerCountry[node.data.id] }} / {{ node.data.isps_count }})
              </span>
              <span v-else class="inline-block align-middle mr-3">
                {{ node.text }}
              </span>
            </template>
          </span>
        </tree>
        <div class="text-gray-600 pt-1" v-show="!isps_db.length">
          Display ISPs according to countries you choose ..
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import {cloneDeep} from 'lodash'

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
        this.isSelectAllChecked(newVal)
      },
      deep: true
    },
    async countries () {
      if (this.countries.length === 0) {
        this.emptyIsps()
        return
      }
      // isps db clone
      const isps_db = cloneDeep(this.isps_db)
      // old value clone before changing it
      const oldValue = cloneDeep(this.value)
      // Remove the isps that it's country removed
      const isps = isps_db.filter(i => !this.countries.includes(i.country_id))
      if (isps.length) {
        this.emptyIsps(isps)
      }
      const response = await window.axios.post('/recommendations/get/isps', {
        countries_ids: this.countries
      })
      const filteredToCheckSelection = isps_db.filter(i => this.countries.includes(i.country_id)).filter(i => !oldValue.includes(i.id))
      response.data.payload.forEach(item => {
        const result = filteredToCheckSelection.findIndex(i => i.id === item.id) === -1 || isps_db.filter(i => oldValue.includes(i.id) && item.country_id === i.country_id).length === 0
        this.addISP(item, result, result)
      })
      // Trigger the check for the select all
      this.isSelectAllChecked(this.value)
    }
  },
  components: {
    Autocomplete
  },
  data () {
    return {
      tree: [],
      isps: [],
      isps_db: [],
      select_all: true,
      filterText: '',
      treeOptions: {
        checkbox: true
      }
    }
  },
  computed: {
    selectIspsCountPerCountry () {
      const counts = []
      this.countries.forEach(countryId => {
        counts[countryId] = this.value.filter(i => this.ispsOfCountry(countryId).map(n => n.id).includes(i)).length
      })
      return counts
    }
  },
  async mounted () {
    // after component is ready i need to check if there is isps in the "main state" if there any will trigger a request and select it
    if (this.value.length || this.countries.length) {
      const response = await window.axios.post('/recommendations/get/isps', {
        countries_ids: this.countries
      })
      response.data.payload.forEach(item => {
        this.addISP(item, false, this.value.includes(item.id))
      })
      setTimeout(() => {
        this.isSelectAllChecked(this.value)
      }, 0)
    }
  },
  methods: {
    addCountry (item) {
      return new Promise((resolve, reject) => {
        if (!this.countries.includes(item.id)) {
          reject('Country dose not exist')
          return
        }
        if (this.$refs.tree.find(item.name).length === 0) {
          this.$refs.tree.prepend({
            text: item.name,
            data: item,
            state: {
              checked: true
            }
          })
        }
        return resolve(true)
      })
    },
    addISP (item, selectAll = true, isSelected = true) {
      this.addCountry(item.country).then(() => {
        // this var indicates if the item is selected or not
        const isItemSelected =  selectAll || isSelected
        // check if item exists
        if (!this.isps.find(i => item.id === i.id)) {
          this.isps.push(item)
        }
        // check if item exists else add it to the db
        if (!this.isps_db.find(i => item.id === i.id)) {
          this.isps_db.push(item)
        }
        if (isItemSelected) {
          if (!this.value.find(i => item.id === i)) {
            this.value.push(item.id)
          }
        }
        const node = this.$refs.tree.find(item.country.name)
        if (node.length && this.$refs.tree.find(item.name).length === 0) {
          node[0].prepend({
            text: item.name,
            data: item,
            state: {
              checked: isItemSelected
            }
          })
        } else if (isItemSelected) {
          this.$refs.tree.find(item.name)[0].check()
        }
      })
    },
    removeISP (item) {
      // remove from this.value
      const valueIndex = this.value.findIndex(i => i === item.id)
      if (valueIndex !== -1) {
        this.value.splice(valueIndex, 1)
      }
      // remove from local stored isps
      const localIndex = this.isps.findIndex(i => item.id === i.id)
      if (localIndex !== -1) {
        this.isps.splice(localIndex, 1)
      }
    },
    /**
     * This function removes ISPS from trr and from the value.
     * If you passed the argument "ispsToRemove" the function will only remove the passed data
     */
    emptyIsps (ispsToRemove = []) {
      let isps = []
      if (ispsToRemove.length === 0) {
        isps = cloneDeep(this.isps_db)
      } else {
        isps = ispsToRemove
      }
      isps.forEach(item => {
        const nodeName = item.country.name
        const node = this.$refs.tree.find(nodeName)
        if (node.length) {
          this.$refs.tree.remove(nodeName)
        }
        this.removeISP(item)
      })
    },
    removeIspFromTree (node) {
      if (node.data.hasOwnProperty('country_id')) { // that means that the node is isp
        this.removeISP(node.data)
      }
    },
    addIspFromTree (node) {
      if (node.data.hasOwnProperty('country_id')) { // that means that the node is isp
        this.addISP(node.data)
      }
    },
    ispsOfCountry (countryId) {
      return this.isps_db.filter(n => n.country_id === countryId)
    },
    isSelectAllChecked (newValue) {
      const isps = cloneDeep(this.isps_db.filter(i => this.countries.includes(i.country_id)))
      const countries = isps.map(i => i.country)
      const countriesUnique = []
      countries.forEach(country => {
        if (!countriesUnique.find(i => i.id === country.id)) {
          countriesUnique.push(country)
        }
      })
      const total = countriesUnique.map(i => i.isps_count).reduce((a, b) => a + b, 0)
      this.select_all = total === newValue.length
    },
    selectAll () {
      this.$gtag.event('Step3_AdvTab_All')
      // Filter the isps that it's country is selected
      const isps = cloneDeep(this.isps_db).filter(i => this.countries.includes(i.country_id))
      if (!this.select_all) {
        isps.forEach(item => {
          this.removeISP(item)
          // to uncheck
          const node = this.$refs.tree.find(item.name)
          if (node.length) {
            node[0].uncheck()
          }
        })
        return
      }
      isps.forEach(item => {
        this.addISP(item)
        // to check
        const node = this.$refs.tree.find(item.name)
        if (node.length) {
          node[0].check()
        }
      })
    }
  }
}
</script>
